import { colors, layout } from '../../NewHire/v2/styles';
import { AnnualReviewStepDescriptor, AnnualReviewSupervisorAnswers } from '../types';
import { computeSupervisorMissingForStep } from '../utils/supervisorCompletion';

interface SupervisorReviewSummaryProps {
  steps: AnnualReviewStepDescriptor[];
  completedKeys: Set<string>;
  answers: AnnualReviewSupervisorAnswers;
  onJumpToStep: (idx: number) => void;
}

const SupervisorReviewSummary = ({ steps, completedKeys, answers, onJumpToStep }: SupervisorReviewSummaryProps) => {
  return (
    <div>
      <h2 style={{ ...layout.title, marginBottom: 4 }}>Review & Submit</h2>
      <p style={layout.subtitle as any}>
        Confirm that you have completed every section. After submitting, you will be guided through the Growth Plan and
        signature steps.
      </p>
      <ul style={{ marginTop: 16, paddingLeft: 18 }}>
        {steps
          .filter((s) => s.key !== 'review_submit')
          .map((s, idx) => {
            const done = completedKeys.has(s.key);
            const missing = done ? [] : computeSupervisorMissingForStep(s.key, answers);
            return (
              <li key={s.key} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <strong>{s.title}</strong>
                  <span style={{ color: done ? colors.success : colors.danger, fontWeight: 600 }}>
                    — {done ? 'completed' : 'pending'}
                  </span>
                  {!done ? (
                    <button
                      type="button"
                      onClick={() => onJumpToStep(idx)}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: colors.primary,
                        cursor: 'pointer',
                        fontSize: 12,
                        padding: 0,
                        textDecoration: 'underline',
                      }}
                    >
                      Go to section →
                    </button>
                  ) : null}
                </div>
                {missing.length ? (
                  <ul style={{ marginTop: 6, paddingLeft: 18, color: colors.muted, fontSize: 13 }}>
                    {missing.map((m) => (
                      <li key={m}>{m}</li>
                    ))}
                  </ul>
                ) : null}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default SupervisorReviewSummary;
